<template>
  <div class="calendar-links clndrlinks">
    <div
      v-if="hasMessage"
      class="clndrlinks_message text-center"
      v-html="$t('messages.add_coaching_to_calendar')"
    ></div>
    <div class="clndrlinks_content">
      <a
        target="_blank"
        href="https://calendar.google.com/calendar/u/7?cid=Y182ZGI2M2EzNDZmNjIwNzBiNmM4MjA4ZDJiN2ViZWM0NzkyNjU3NmUyNjI2ZTYzMjZjNTUyZTk5YWU5NDZlNzE5QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20"
        class="clr-white clndrlinks_item gw_btn gw_btn_text"
      >
        <div class="clndrlinks_item_svg_holder">
          <GoogleCalendar class="clndrlinks_item_svg" />
        </div>
        <div class="clndrlinks_item_text text-nowrap">
          {{ $t('common.google') }}
          <!-- {{ $t('common.google_calendar') }} -->
        </div>
      </a>
      <a
        target="_blank"
        href="webcal://p64-caldav.icloud.com/published/2/MTgxMzI1NDg3OTIxODEzMgDyRcNWs578CtsRQ95hkpH_zQBooI48OQlQ4hAHgpQBRFZHtxuKO-_XB1pxADZ1xqr4i0XcbmNzgD45cJ7T1v8"
        class="clr-white clndrlinks_item gw_btn gw_btn_text"
      >
        <div class="clndrlinks_item_svg_holder">
          <IosCalendar class="clndrlinks_item_svg" />
        </div>
        <!-- <div class="clndrlinks_item_text">{{ $t('common.ios_calendar') }}</div> -->
        <div class="clndrlinks_item_text text-nowrap">
          {{ $t('common.ios') }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import GoogleCalendar from '@/assets/google_calendar.svg'
import IosCalendar from '@/assets/ios_calendar.svg'

export default {
  name: 'CalendarLinks',

  components: {
    GoogleCalendar,
    IosCalendar,
  },
  props: {
    hasMessage: { type: Boolean, default: true },
    // items: { default: () => [] },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.clndrlinks {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  justify-content: var(--justify-content);

  --justify-content: center;
  --size: 6.5rem;
  --size-icon: 3rem;
  --clr-coaching: var(--clr-primary);
  // --clr-coaching: var(--clr-blue);
  --font-size: 0.8rem;
  --font-size-message: 1.25rem;
  --padding-message: 1.5rem;
  --weight-message: 600;
  --item-flex-direction: column;
  --padding-item: 1rem;

  &_message {
    font-size: var(--font-size-message);
    font-weight: var(--weight-message);
    padding: var(--padding-message);
  }
  &_content {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
    flex-shrink: 0;
  }
  &_item {
    height: var(--size);
    font-size: var(--font-size);
    flex-direction: var(--item-flex-direction);
    display: flex;
    gap: 0.75rem;
    padding: var(--padding-item);
    flex-shrink: 0;
    &_svg_holder {
      flex-shrink: 0;
      position: relative;
      height: var(--size-icon);
      width: var(--size-icon);
    }
    &_svg {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    &_text {
      position: relative;
      font-weight: 500;
    }
  }
}
</style>
